// extracted by mini-css-extract-plugin
export default {"container":"Search_container__jmPch","search-container":"Search_search-container__aHJVQ","filter-chip":"Search_filter-chip__WiBuU","active":"Search_active__6U7Jj"};